import { jsxs as b, jsx as a, Fragment as E } from "react/jsx-runtime";
import N from "react";
import { u as c } from "./index-6a632112.mjs";
import { S as O } from "./warningFilled-691cfde1.mjs";
import { f as T, s as o, r as y, b as $, e as l, c as v, d as W, a as S } from "./themes-5f0b3c3d.mjs";
import { l as w } from "./lineHeights-72d3110c.mjs";
import { ScreenReaderOnly as D } from "./screenReaderOnly.js";
const C = 99999, k = -99999, R = "INCREMENT_SELECTOR_INPUT_ID";
function G(e) {
  const t = {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  };
  switch (e) {
    case "small":
      t.width = "20px", t.height = "20px";
      break;
    case "medium":
      t.width = "24px", t.height = "24px";
      break;
    case "large":
      t.width = "32px", t.height = "32px";
      break;
    default:
      t.width = "24px", t.height = "24px";
  }
  return t;
}
const H = c.div`
  display: inline-flex;
  flex-direction: column;
  font-family: ${T.inter}, sans-serif;
  gap: ${o["2x"]};
`, _ = c.div`
  border-radius: ${y["2x"]};
  position: relative;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: ${o["1x"]};
  display: inline-flex;
  gap: ${o["1x"]};

  ${(e) => `
      background-color: ${e.theme.components.incrementSelector.defaultBackgroundColor};
      border: ${$["1x"]} solid ${e.theme.components.incrementSelector.border};
      `}

  ${(e) => {
  switch (e.$textSize) {
    case "small":
      return `
          height: ${o["10x"]};
          width: ${o["28x"]};
        `;
    case "large":
      return `
          height: ${o["14x"]};
          width: 160px;
        `;
    case "medium":
    default:
      return `
          height: ${o["12x"]};
          width: 136px; 
        `;
  }
}}
`, M = c.span`
  font-family: ${l.regular.S.fontFamily};
  font-size: ${l.regular.S.fontSize};
  font-style: normal;
  font-weight: ${l.regular.S.fontWeight};
  line-height: ${l.regular.S.lineHeight};
  display: flex;
  user-select: none;
  align-items: center;

  color: ${({ $isInvalid: e, $isDisabled: t, theme: i }) => e ? i.colors.status.errorHoverColor : t ? i.components.incrementSelector.textColorDisabled : i.components.incrementSelector.textColorHelperText};

  span {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  svg {
    fill: ${(e) => e.theme.colors.status.errorHoverColor};
  }
`, L = c.label`
  font-family: ${l.medium.S.fontFamily};
  font-size: ${l.medium.S.fontSize};
  font-style: normal;
  font-weight: ${l.medium.S.fontWeight};
  line-height: ${l.medium.S.lineHeight};

  color: ${(e) => e.theme.components.incrementSelector.textColorLabel};

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`, J = ({
  value: e,
  label: t,
  textSize: i = "medium",
  showErrorIcon: d = !1,
  helperText: m = "",
  isInvalid: r = !1,
  isDisabled: u = !1,
  onChange: h,
  children: p = [],
  min: x = k,
  max: g = C,
  htmlForId: s = R,
  showRequiredIndicator: n = !1,
  ...f
}) => /* @__PURE__ */ b(H, { ...f, children: [
  /* @__PURE__ */ b(L, { htmlFor: s, id: `${s}-labelledby-id`, children: [
    t,
    t && n && /* @__PURE__ */ a(
      "span",
      {
        "aria-hidden": "true",
        style: { color: v.utilityDanger[1e3] },
        children: " *"
      }
    )
  ] }),
  /* @__PURE__ */ a(_, { $textSize: i, children: p.map(
    (z, I) => N.cloneElement(z, {
      textSize: i,
      onClick: h,
      value: e,
      isFullyDisabled: u,
      isInvalid: r,
      htmlFor: s,
      min: x,
      max: g,
      key: `increment-selector-child-${I}`
    })
  ) }),
  /* @__PURE__ */ b(
    M,
    {
      "aria-live": "polite",
      role: "alert",
      $isInvalid: r,
      $isDisabled: u,
      children: [
        r && d && /* @__PURE__ */ a(
          O,
          {
            color: v.utilityDanger[1e3],
            style: { marginRight: o["2x"] },
            width: 16,
            height: 16,
            role: "img"
          }
        ),
        /* @__PURE__ */ a("span", { children: m })
      ]
    }
  )
] }), P = c.div`
  display: flex;

  ${({ $textSize: e }) => {
  switch (e) {
    case "small":
      return `
          width:${o["8x"]};
          height:${o["8x"]};
        `;
    case "large":
      return `
          width:${o["12x"]};
          height:${o["12x"]};
        `;
    case "medium":
    default:
      return `
          width:${o["10x"]};
          height:${o["10x"]};
        `;
  }
}};

  &:focus-visible {
    outline: none;
  }
`, j = c.div`
  ${({ $textSize: e }) => {
  switch (e) {
    case "small":
      return `
          width:${o["8x"]};
          height:${o["8x"]};
        `;
    case "large":
      return `
          width:${o["12x"]};
          height:${o["12x"]};
        `;
    case "medium":
    default:
      return `
          width:${o["10x"]};
          height:${o["10x"]};
        `;
  }
}};

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  border-radius: ${y["2x"]};
  color: ${(e) => e.theme.components.incrementSelector.textColor};

  &:hover {
    background-color: ${({ theme: e }) => e.components.incrementSelector.iconHoverBackgroundColor};
  }
  &:focus-visible {
    outline: ${$["2x"]} solid
      ${({ theme: e }) => e.components.incrementSelector.iconFocusRingColor};
  }

  &.disabled {
    cursor: default;
    color: ${(e) => e.theme.components.incrementSelector.textColorDisabled};

    &:hover {
      background-color: unset;
    }
    &:focus-visible {
      outline: none;
    }
  }

  &.disabledPlusMinus {
    color: ${(e) => e.theme.components.incrementSelector.textColorDisabled};
  }
`, Q = ({
  textSize: e = "medium",
  isDisabled: t = !1,
  isFullyDisabled: i = !1,
  children: d,
  variant: m,
  value: r = 0,
  min: u = k,
  max: h = C,
  onClick: p,
  accessibilityOptions: x = {},
  ...g
}) => {
  function s(n) {
    n.preventDefault(), n.stopPropagation(), !i && !t && (m === "subtract" && r - 1 >= u ? p?.(r - 1) : m === "add" && r + 1 <= h && p?.(r + 1));
  }
  return /* @__PURE__ */ a(P, { $textSize: e, children: /* @__PURE__ */ a(
    j,
    {
      onClick: s,
      onKeyDown: (n) => {
        (n.code === "Enter" || n.code === "Space") && s(n);
      },
      className: `${i || t ? "disabled" : ""} ${t ? "disabledPlusMinus" : ""}`,
      $textSize: e,
      ...x,
      children: d
    }
  ) });
}, F = c.input`
  display: flex;
  box-sizing: border-box;
  padding: ${o["1x"]};
  justify-content: center;
  align-items: center;
  gap: 0px;
  flex-shrink: 0;

  border-radius: ${y["2x"]};

  overflow: hidden;
  color: ${({ disabled: e, theme: t }) => e ? t.components.incrementSelector.textColorDisabled : t.components.incrementSelector.textColor};
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;

  font-family: ${W.body};
  font-style: normal;
  font-weight: ${l.regular.L.fontWeight};
  -moz-appearance: textfield;

  border: none;
  background-color: transparent;

  &::-webkit-inner-spin-button {
    display: none;
  }

  outline: ${({ $isInvalid: e, theme: t }) => e && `${$["1x"]} solid ${t.components.incrementSelector.invalidErrorOutlineColor};`};

  ${(e) => {
  if (e.$textSize === "small")
    return `
        width: ${o["6x"]}; 
        height: ${o["6x"]}; 
        font-size: ${S.xsmall}; 
        line-height: ${w.small}; 
      `;
  if (e.$textSize === "medium")
    return `
        width:  ${o["8x"]};
        height:${o["8x"]}; 
        font-size: ${S.small};
        line-height:  ${w.medium};
      `;
  if (e.$textSize === "large")
    return `
        width: ${o["10x"]}; 
        height:${o["10x"]};  
        font-size: ${S.medium};
        line-height:  ${w.large};
      `;
}};

  &:hover {
    outline: ${$["1x"]} solid
      ${({ $isInvalid: e, disabled: t, theme: i }) => e ? i.components.incrementSelector.invalidErrorOutlineColor : t ? "none" : i.components.incrementSelector.textInputOutlineColor};
  }

  &:focus-visible {
    outline: ${$["2x"]} solid
      ${({ $isInvalid: e, theme: t }) => e ? t.components.incrementSelector.invalidErrorOutlineColor : t.components.incrementSelector.textInputOutlineColor};
  }
`, Y = ({
  textSize: e = "medium",
  value: t = 0,
  isFullyDisabled: i = !1,
  onClick: d,
  min: m = k,
  max: r = C,
  isInvalid: u = !1,
  htmlForId: h,
  isRequired: p = !1,
  ...x
}) => {
  function g(n) {
    if (n.key !== "Tab" && (t.toString().length === 1 && n.key === "Backspace" || /[^0-9-]/.test(n.key) && n.key !== "Backspace" && n.key !== "ArrowLeft" && n.key !== "ArrowRight"))
      return n.stopPropagation(), n.preventDefault(), !1;
  }
  function s(n) {
    if (!i) {
      const f = parseInt(n.currentTarget.value);
      f < m || f > r || isNaN(f) ? d?.(t) : d?.(f);
    }
  }
  return /* @__PURE__ */ b(E, { children: [
    /* @__PURE__ */ a(
      F,
      {
        "aria-labelledby": `${h}-labelledby-id`,
        $textSize: e,
        $isInvalid: u,
        type: "number",
        value: t,
        onKeyDown: g,
        onChange: s,
        disabled: i,
        "aria-required": p,
        ...x,
        id: h
      }
    ),
    /* @__PURE__ */ a(D, { "aria-live": "assertive", children: t })
  ] });
};
export {
  J as I,
  k as M,
  Y as N,
  Q as S,
  C as a,
  G as g
};
